import { IsoCountryCode } from "../models/user";
import { SERegionFunctions } from "./region-functions-se";
import { NORegionFunctions } from "./region-functions-no";
import { DKRegionFunctions } from "./region-functions-dk";
import { ESRegionFunctions } from "./region-functions-es";
import { FIRegionFunctions } from "./region-functions-fi";
import { NLRegionFunctions } from "./region-functions-nl";
import { BERegionFunctions } from "./region-functions-be";
import { FRRegionFunctions } from "./region-functions-fr";

type RegionContext = {
	regionFunctions: IRegionFunctions;
};
export type ParsedAccount = {
	clearingNumber: string;
	accountNumber: string;
	error?: { message: string };
};
export interface IRegionFunctions {
	validPhoneNumber: (phoneNumber: string) => boolean;
	formatPhoneNumber: (phoneNumber: string) => string;
	validateAccountNumber: (accountNumber: string) => boolean;
	parseAccountNumber: (accountNr: string) => ParsedAccount;
	validateIban: (IBAN: string, allowedCountryCodes?: string) => boolean;
	formatAccountNumber: (clearingNumber: string, accountNr: string) => string;
	bankAccountMeta: (accountNrIncludingClearing: string) => {
		clearingNumberLength: number;
		accountNumberMaxLength: number;
	};
}

const regionFunctions = {
	[IsoCountryCode.SE]: SERegionFunctions,
	[IsoCountryCode.NO]: NORegionFunctions,
	[IsoCountryCode.DK]: DKRegionFunctions,
	[IsoCountryCode.ES]: ESRegionFunctions,
	[IsoCountryCode.FI]: FIRegionFunctions,
	[IsoCountryCode.NL]: NLRegionFunctions,
	[IsoCountryCode.BE]: BERegionFunctions,
	[IsoCountryCode.FR]: FRRegionFunctions,
} as const;

const supportedRegions = Object.keys(regionFunctions);
const isSupportedRegion = (countryCode: IsoCountryCode): countryCode is keyof typeof regionFunctions => {
	return supportedRegions.some((region) => region === String(countryCode));
};

export const useRegionfunctions = (countryCode?: IsoCountryCode): RegionContext => {
	const code = countryCode ?? IsoCountryCode.SE;
	if (!isSupportedRegion(code)) throw Error("There is no region functions for the country code");
	return { regionFunctions: regionFunctions[code] };
};
